export default __webpack_public_path__ + "static/media/7.4b7c0cff.jpg";